export default "Projet de résolution AG — Copropriétés | Solution Éco France";
